<template lang="pug">
#resumo-alertas
    .titulo.mb-3
        h3 Últimos alertas
        h3 Total acumulado

    .resumo-alertas
        LinhaResumoAlertas.mb-2(
            :corIcone='cor["diario"]',
            :dias='1',
            :qtdAlertas='resumoAlertas.totalDiario'
        )
        LinhaResumoAlertas.mb-2(
            :corIcone='cor["semanal"]',
            :dias='7',
            :qtdAlertas='resumoAlertas.totalSemanal'
        )
        LinhaResumoAlertas.mb-2(
            :corIcone='cor["mensal"]',
            :dias='30',
            :qtdAlertas='resumoAlertas.totalMensal'
        )
        LinhaResumoAlertas.mb-2(
            :corIcone='cor["trimestral"]',
            :dias='90',
            :qtdAlertas='resumoAlertas.totalTrimestral'
        )
</template>

<script>
import LinhaResumoAlertas from '@/components/alertas/resumo/LinhaResumoAlertas.vue';
import AlertaService from '@/services/AlertaService.js';

export default {
    name: 'ResumoAlertas',

    components: {
        LinhaResumoAlertas
    },

    data() {
        return {
            resumoAlertas: {
                totalDiario: 0,
                totalSemanal: 0,
                totalMensal: 0,
                totalTrimestral: 0
            },
            cor: {
                semanal: '#FD9453',
                mensal: '#FBB658',
                diario: '#FF484E',
                trimestral: '#F8D95D'
            }
        };
    },

    created() {
        this.getResumoAlertas();
    },

    methods: {
        getResumoAlertas() {
            AlertaService.getResumoAlertas()
                .then(({ data }) => {
                    this.resumoAlertas = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar o resumo dos alertas' +
                            erro
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#resumo-alertas {
    min-width: 300px;

    .titulo {
        display: flex;
        justify-content: space-around;
    }
}
</style>
